/** External links are values, never HTML. Shared by imported and authored messages. */
export function safeMessageUrl(value: string): string | null {
  if (/\s/u.test(value) || Array.from(value).some((c) => c.charCodeAt(0) < 32 || c.charCodeAt(0) === 127))
    return null;
  try {
    const url = new URL(value);
    if (!['https:', 'http:', 'mailto:'].includes(url.protocol) || url.username || url.password) return null;
    return url.href;
  } catch {
    return null;
  }
}
